module.exports = __webpack_public_path__ + "img/1761405.png";